import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type OptionsService from '@linc-technologies/linced-common/services/options';

interface SchoolOptionSignature {
  Args: { Positional: [key: string] };
  Return: unknown;
}

// school-option gives the value of a school option for the session school,
// or its default. It updates when the school or the value changes.
//
// Usage: {{#if (school-option "hero:features:qrcodes")}}
export default class SchoolOption extends Helper<SchoolOptionSignature> {
  @service
  declare options: OptionsService;

  compute([key]: [string]): unknown {
    return this.options.value(key);
  }
}
